import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "icon-bank-grey_svg__icon-bank-grey" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "icon-bank-grey_svg__Vector",
    d: "M1.17405 4.469L8.00105 1L14.8291 4.469C15.1241 4.625 15.0151 5.063 14.6891 5.063H14.0671V5.688C14.0671 5.859 13.9271 6 13.7561 6H2.24605C2.16374 5.99921 2.08504 5.96602 2.02702 5.90763C1.96899 5.84923 1.93631 5.77032 1.93605 5.688V5.063H1.31205C0.986055 5.063 0.877055 4.625 1.17205 4.469H1.17405ZM14.6901 13.25H1.31105C1.14005 13.25 1.00005 13.381 1.00005 13.542V15H15.0001V13.542C15.0001 13.382 14.8601 13.25 14.6891 13.25H14.6901ZM4.10705 6.75H2.69305C2.59905 6.75 2.53605 6.81 2.53605 6.901V10.987H2.06605C1.98434 10.9857 1.90541 11.0166 1.84642 11.0732C1.78742 11.1297 1.75315 11.2073 1.75105 11.289V12.5H14.0011V11.29C13.9992 11.2083 13.9652 11.1306 13.9064 11.0739C13.8476 11.0172 13.7688 10.9859 13.6871 10.987H13.2161V6.9C13.2161 6.81 13.1531 6.749 13.0591 6.749H11.6451C11.5511 6.749 11.4881 6.809 11.4881 6.9V10.986H10.2321V6.9C10.2321 6.81 10.1691 6.749 10.0751 6.749H8.66105C8.56705 6.749 8.50405 6.809 8.50405 6.9V10.986H7.24805V6.9C7.24805 6.81 7.18505 6.749 7.09105 6.749H5.67705C5.58306 6.749 5.52005 6.809 5.52005 6.9V10.986H4.26405V6.9C4.26405 6.81 4.20105 6.75 4.10705 6.75Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }